import React from 'react';
import { fmt$, ModuleHeader } from '../shared/formFields';

export function FundingRevenueModule({ loan }) {
  return (
    <div className="space-y-4">
      <ModuleHeader title="Funding / Revenue" />
      <div className="bg-white rounded-xl border border-slate-200 p-5">
        <div className="grid md:grid-cols-3 gap-4">
          <div>
            <div className="text-[10px] uppercase tracking-widest font-bold text-slate-500">Funded Amount</div>
            <div className="text-2xl font-bold" style={{ color: '#030524' }}>{loan.status === 'funded' ? fmt$(loan.loan_amount) : '—'}</div>
          </div>
          <div>
            <div className="text-[10px] uppercase tracking-widest font-bold text-slate-500">Estimated LO Comp</div>
            <div className="text-2xl font-bold" style={{ color: '#6BA82E' }}>{fmt$((loan.loan_amount || 0) * 0.0125)}</div>
            <div className="text-[10px] text-slate-500">125 bps default</div>
          </div>
          <div>
            <div className="text-[10px] uppercase tracking-widest font-bold text-slate-500">Broker Comp / YSP</div>
            <div className="text-2xl font-bold" style={{ color: '#030524' }}>—</div>
          </div>
        </div>
      </div>
    </div>
  );
}
